// extracted by mini-css-extract-plugin
export var arrowBlock = "main-module--arrow-block--fbe0a";
export var arrowBtn = "main-module--arrow-btn--5d2d0";
export var btn = "main-module--btn--2801e";
export var centeredBtnBlock = "main-module--centered-btn-block--f654d";
export var title = "main-module--title--5dbcb";